export const LOAD__PRO_STORE = 'LOAD__PRO_STORE';
export const SUBMIT_PRO_PROFILE = 'SUBMIT_PRO_PROFILE';
export const PRO_STORE_SEARCH = 'PRO_STORE_SEARCH';
